module.exports = __webpack_public_path__ + "105b4bcb1d4d24142b34876eff94fa50.svg";